import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { join } from 'lodash';
import {
  FormSectionWarnHeading,
  GridItem,
  TextFieldWrapper,
} from '../../common';

const ADDITIONAL_NOTES = 'additionalNotes';

function SpecialCareConcern({ paths }) {
  return (
    <React.Fragment>
      <FormSectionWarnHeading>
        IMPORTANT! - Special Care Concerns
      </FormSectionWarnHeading>
      <GridItem xs={12}>
        <Field
          component={TextFieldWrapper}
          id={ADDITIONAL_NOTES}
          label="Add Additional Notes"
          multiline
          name={join([...paths, ADDITIONAL_NOTES], '.')}
          paths={[...paths, ADDITIONAL_NOTES]}
        />
      </GridItem>
    </React.Fragment>
  );
}

SpecialCareConcern.propTypes = {
  paths: PropTypes.array,
};

SpecialCareConcern.defaultProps = {
  paths: [],
};

export default SpecialCareConcern;



// WEBPACK FOOTER //
// ./src/modules/ChildInformationPage/components/SpecialCareConcern.js